import React from "react";
import { ImageThumbnail } from "../../../common/components/ImageThumbnail";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
/** @jsx jsx */
import { jsx } from "@emotion/react";
import formsCss from "../../../common/styles/forms.css";
import XLSX from "xlsx";
import { FileUploadIcon, PdfIcon, InsertDriveFileIcon } from "../../../common/components/icons";

const handleChange = (fileOnChange, onChangeCallback) => file => {
    fileOnChange(file);
    if (onChangeCallback) onChangeCallback();
};
const onClearClick = (fileOnChange, onClearCallback) => () => {
    fileOnChange(null);
    if (onClearCallback) onClearCallback();
};
const onRemoveClick = (removeOnChange, oldValue, onClearCallback) => () => {
    removeOnChange(!oldValue);
    if (onClearCallback) onClearCallback();
};

const renderFileInput = ({
    names: [propFile, propUrl, propRemove],
    errorRes,
    classes,
    onChangeCallback,
    onClearCallback,
    ...fieldProps
}) => {
    const fileInput = fieldProps[propFile].input;
    const { onChange, ...inputProps } = { ...fileInput };
    const meta = fieldProps[propFile].meta;
    const urlField = fieldProps[propUrl];
    const removeField = fieldProps[propRemove];

    const urlExtension = urlField
        ? urlField.input.value.substr(urlField.input.value.lastIndexOf(".") + 1).toLowerCase()
        : "";
    const uploadExtension = inputProps.value
        ? inputProps.value.name.substr(inputProps.value.name.lastIndexOf(".") + 1).toLowerCase()
        : "";
    delete fieldProps[propFile];
    delete fieldProps[propUrl];
    delete fieldProps[propRemove];
    const randomID = Math.floor(Math.random() * 100);

    return (
        <div>
            <label htmlFor={`button-file-${randomID}`} css={formsCss.btnLabel}>
                <Button variant="contained" color="secondary" component="span">
                    <div css={formsCss.hiddenInputFile}>
                        <FileBase64
                            onDone={handleChange(onChange, onChangeCallback)}
                            type="file"
                            id={`button-file-${randomID}`}
                            {...inputProps}
                            {...fieldProps}
                        />
                    </div>
                    <FileUploadIcon css={formsCss.btnIcon} />
                    Choose a File
                </Button>
            </label>

            {/* preview previously uploaded file by URL */}
            {propUrl &&
                urlField.input.value &&
                !inputProps.value &&
                (urlExtension === "pdf" ? (
                    <Button
                        href={urlField.input.value}
                        target="blank"
                        variant="contained"
                        color="secondary"
                        classes={{
                            containedSecondary: classes.buttonPDF,
                        }}
                    >
                        <PdfIcon css={formsCss.btnIcon} />
                        Preview
                    </Button>
                ) : (
                    <ImageThumbnail
                        imageUrl={urlField.input.value}
                        removeField={removeField && removeField.input.value}
                    />
                ))}

            {/* preview just uploaded file (by base64 content) */}
            {inputProps.value &&
                (uploadExtension === "jpg" ||
                uploadExtension === "jpeg" ||
                uploadExtension === "gif" ||
                uploadExtension === "png" ? (
                    <ImageThumbnail
                        imageFile={inputProps.value}
                        removeField={removeField && removeField.input.value}
                    />
                ) : (
                    inputProps.value &&
                    inputProps.value.name && (
                        <span css={formsCss.fileLabel}>
                            <InsertDriveFileIcon />
                            <span css={formsCss.fileLabelText}>{inputProps.value.name}</span>
                        </span>
                    )
                ))}

            {/* additional feature - clear file prepared to upload (does not remove already uploaded file on server) */}
            {inputProps.value.base64 && (
                <div css={formsCss.extraAction}>
                    <Button
                        classes={{ text: classes.buttonTextExtraAction }}
                        onClick={e => {
                            onClearClick(onChange, onClearCallback)(e);
                        }}
                    >
                        {propUrl && urlField.input.value ? "restore original" : "clear upload"}
                    </Button>
                </div>
            )}

            {/* mark file for removal */}
            {!inputProps.value.base64 && urlField && urlField.input.value && removeField && (
                <div css={formsCss.extraAction}>
                    <Button
                        classes={{ text: classes.buttonTextExtraAction }}
                        onClick={onRemoveClick(
                            removeField.input.onChange,
                            removeField.input.value,
                            onClearCallback
                        )}
                    >
                        {removeField.input.value ? "restore original" : "remove image"}
                    </Button>
                </div>
            )}
            {meta.touched && (
                <span css={formsCss.error}>{meta.touched && (meta.error || errorRes)}</span>
            )}
        </div>
    );
};

/*! Copyright (c) 2016 Naufal Rabbani (http://github.com/BosNaufal)
 * Licensed Under MIT (http://opensource.org/licenses/MIT)
 *
 * React File Base64 - Version@1.0.0
 *
 */

class FileBase64 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
        };
    }

    onFileUploaded(e) {
        // get the files
        let files = e.target.files;

        // Process each file
        var allFiles = [];
        for (var i = 0; i < files.length; i++) {
            let file = files[i];

            // Make new FileReader
            let reader = new FileReader();

            const filename = file.name.split(".");
            const ext = filename[filename.length - 1].toLowerCase();

            // parsing excel file - use parsed array of data
            if (
                !!this.props.parseSpreadsheetOnUpload &&
                (ext === "xlsx" || ext === "xls" || ext === "csv")
            ) {
                // Convert the file to base64 text
                reader.readAsArrayBuffer(file);

                // on reader load somthing...
                reader.onload = e => {
                    var data = new Uint8Array(e.target.result);
                    var readedData = XLSX.read(data, { type: "array" });
                    const wsname = readedData.SheetNames[0];
                    const ws = readedData.Sheets[wsname];
                    const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1, blankRows: false });

                    // Make a fileInfo Object
                    let fileInfo = {
                        name: file.name,
                        type: file.type,
                        size: Math.round(file.size / 1000) + " kB",
                        data: dataParse,
                        // base64: ¯\_(ツ)_/¯
                        file: file,
                    };

                    // Push it to the state
                    allFiles.push(fileInfo);

                    // If all files have been proceed
                    if (allFiles.length === files.length) {
                        // Apply Callback function
                        if (this.props.multiple) this.props.onDone(allFiles);
                        else this.props.onDone(allFiles[0]);
                        this.myInput.value = "";
                    }
                }; // reader.onload
            }
            // parsing some other file? use base64 encoded result
            else {
                // Convert the file to base64 text
                reader.readAsDataURL(file);

                // on reader load somthing...
                reader.onload = () => {
                    // Make a fileInfo Object
                    let fileInfo = {
                        name: file.name,
                        type: file.type,
                        size: Math.round(file.size / 1000) + " kB",
                        base64: reader.result,
                        file: file,
                    };

                    // Push it to the state
                    allFiles.push(fileInfo);
                    // If all files have been proceed
                    if (allFiles.length === files.length) {
                        // Apply Callback function
                        if (this.props.multiple) this.props.onDone(allFiles);
                        else this.props.onDone(allFiles[0]);
                        this.myInput.value = "";
                    }
                }; // reader.onload
            }
        } // for
    }

    render() {
        return (
            <input
                type="file"
                onChange={this.onFileUploaded.bind(this)}
                multiple={this.props.multiple}
                id={this.props.id}
                ref={el => (this.myInput = el)}
                accept={this.props.accept ? this.props.accept : undefined}
            />
        );
    }
}

FileBase64.defaultProps = {
    multiple: false,
};

export const RenderFileInput = withStyles(formsCss)(renderFileInput);
